module.exports = __webpack_public_path__ + "static/media/early-version-1.bffcf516.png";